import React from "react";

interface TableSortIconProps {
  sorted?: boolean;
  sortOrder?: number | null;
}

const SORT_ICON_DEFAULT_COLOR = "#7C7F7E";
const SORT_ICON_ACTIVE_COLOR = "#065FA6";

export const TableSortIcon = ({
  sorted = false,
  sortOrder,
}: TableSortIconProps) => {
  const isAscending = sorted && (sortOrder ?? 0) > 0;
  const isDescending = sorted && (sortOrder ?? 0) < 0;

  return (
    <span className="table-sort-icon" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M11.5 5.5L8.75258 2.36009C8.40211 1.95956 8.22688 1.7593 8 1.7593C7.77312 1.7593 7.59789 1.95956 7.24742 2.36009L4.5 5.5"
          stroke={isAscending ? SORT_ICON_ACTIVE_COLOR : SORT_ICON_DEFAULT_COLOR}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5 10.5L8.75258 13.6399C8.40211 14.0404 8.22688 14.2407 8 14.2407C7.77312 14.2407 7.59789 14.0404 7.24742 13.6399L4.5 10.5"
          stroke={isDescending ? SORT_ICON_ACTIVE_COLOR : SORT_ICON_DEFAULT_COLOR}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export const renderTableSortIcon = (options: TableSortIconProps) => (
  <TableSortIcon {...options} />
);
